import request from "@utils/request";

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
    return request.post("/login", data, { login: false });
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
    return request.post("/login/mobile", data, { login: false });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
    return request.post("/register/verify", data, { login: false });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
    return request.post("/register", data, { login: false });
}

/**
 * 用户手机号注册_微信授权后
 * @param data object 用户手机号 验证码 密码
 */
export function register_h5(data) {
    return request.post("/h5register", data, { login: false });
}

/**
 * 用户手机号注册_微信授权后
 * @param data object 用户手机号 验证码 密码
 */
export function register_wx(data) {
    return request.post("/wxregister", data, { login: false });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
    return request.post("/register/reset", data, { login: false });
}

/*
 * 领取优惠券列表
 * */
export function getCoupon(q) {
    return request.get("/coupons", q, { login: false });
}

/*
 * 点击领取优惠券
 * */
export function getCouponReceive(id) {
    return request.post("/coupon/receive", { couponId: id }, { login: true });
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
    return request.post("/coupon/receive/batch", { couponId });
}
/*
 * 绑定手机号
 * */
export function bindPhone(data) {
    return request.post("/bind_phone", data, { login: false });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(type) {
    return request.get("/coupons/user/" + type);
}

/*
 * 个人中心
 * */
export function getUser() {
    return request.get("/user");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
    return request.get("/userinfo", { login: false });
}
/**
 * 我的团队
 */
export function getMyTeamList(data) {
    return request.post("/user/my_team_list", data, { login: false })
}
// 我的业绩详情
export function myPerformance(data) {
    return request.post("/user/my_performance", data, { login: false })
}
// 子公司业绩
export function myCompanyPerformance(data) {
    return request.post("/user/my_company_performance", data, { login: false })
}
// 子公司人员详情
export function myCompanyInfo(data) {
    return request.post("/user/my_company_info", data, { login: false })
}
// 子公司人员
export function myCompany(data) {
    return request.post("/user/my_company", data, { login: false })
}
// 子公司详情
export function childDetail() {
    return request.post("/subsidiary_introduction", {}, { login: false })
}
/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
    return request.get("/menu/user");
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
    return request.get("/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
    return request.post("/address/del", { id: id });
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
    return request.post("/address/default/set", { id: id });
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
    return request.get("/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
    return request.get("/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
    return request.post("/address/edit", data);
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
    return request.get("/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
    return request.post("/collect/del", { id: id, category: category });
}
/*
 * 取消收藏产品
 * */
export function postCollectAllDel(id) {
    return request.post("/collect/all_del", { id: id });
}
/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
    return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
    return request.post("collect/add", { id: id, category: category });
}
/**
 * 客服
 */
export function customerService() {
    return request.get("/customer_service", {}, { login: false })
}
/*
 * 签到配置
 * */
export function getSignConfig() {
    return request.get("/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
    return request.get("/sign/list", { page: page, limit: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
    return request.get("/sign/month", { page: page, limit: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
    return request.post("/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
    return request.post("/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo() {
    return request.get("/commission");
}

/*
 * 推广人列表
 * */
export function getSpreadUser(screen) {
    return request.post("/spread/people", screen);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(where) {
    return request.post("/spread/order", where);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
    return request.get("/spread/commission/" + types, q);
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
    return request.get("/integral/list", q);
}

/*
 * 提现银行
 * */
export function getBank() {
    return request.get("/extract/bank");
}

/*
 * 提现申请
 * */
export function postCashInfo(cash) {
    return request.post("/extract/cash", cash);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
    return request.get("/user/level/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
    return request.get("/user/level/task/" + id);
}

/*
 * 资金统计
 * */
export function getBalance() {
    return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
    return request.get("/user/activity", {}, { login: false });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
    return request.get("/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
    return request.post("/user/edit", data);
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
    return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
    return request.get("user/service/list");
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
    return request.post("/recharge/wechat", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
    return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
    return request.post("binding", data);
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
    return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取推广人排行
 * */
export function getRankList(q) {
    return request.get("rank", q);
}
/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
    return request.get("brokerage_rank", q);
}
/**
 * 检测会员等级
 */
export function setDetection() {
    return request.get("user/level/detection");
}
/**
 * 充值金额选择
 */
export function getRechargeApi() {
    return request.get("recharge/index");
}
/**
 * 验证码key
 */
export function getCodeApi() {
    return request.get("verify_code", {}, { login: false });
}
/**
 * 注册条款
 * 千叶
 */
export function clause() {
    return request.get("registration_terms", {}, { login: false });
}
/**
 * 银行卡信息
 * 千叶
 */
export function bankCard(data) {
    return request.post("user/find_bank_card", data, { login: false });
}
/**
 * 保存或者更改用户银行卡信息
 * 千叶
 */
export function saveCard(data) {
    return request.post("user/save_bank_card", data);
}
/**
 * 鲍氏首页/商品等显示是否填写
 * 千叶
 */
export function queryCard(data) {
    return request.post("user/bank_card", data, { login: false });
}
/**
 * 查询是否绑定结算卡
 * 梦
 */
export function queryBindStatus(data) {
    return request.post("user/bind_zfb_result", data, { login: false });
}
/**
 * 绑定结算卡
 * 梦
 */
export function submitBindAccount(data) {
    return request.post("user/bind_zfb", data, { login: false });
}
/**
 * 我的消息
 * 千叶
 */
export function news(data) {
    return request.post("user/user_message", data);
}
/**
 * 我的消息已读
 * 千叶
 */
export function readNews(data) {
    return request.post("user/read_user_message", data);
}
/**
 * 我的收入
 * 千叶
 */
export function inCome(data) {
    return request.post("user/my_income", data);
}
/**
 * 视频分类
 * 千叶
 */
export function videoCate() {
    return request.post("video_cate");
}
/**
 * 视频列表
 * 千叶
 */
export function videoLists(data) {
    return request.post("video_list", data);
}
/**
 * 邀请记录
 * 千叶
 */
export function recordList(data) {
    return request.post("user/my_company_info", data);
}
/**
 * 新人专区介绍
 * 千叶
 */
export function newIntrduction(data) {
    return request.post("new_area_introduction", data);
}
/**
 * 删除全部消息
 * 千叶
 */
export function readAll() {
    return request.post("user/del_user_message");
}
/**
 * 积分规则
 * 千叶
 */
export function interRule() {
    return request.post("rules_introduction");
}
/**
 * 个人中心收入成绩等
 * 千叶
 */
export function commission(data) {
    return request.post("user_commission", data);
}
/**
 * 我的积分
 * 千叶
 */
export function myIntegral(data) {
    return request.post("user/TaskIntegral", data);
}
/**
 * 新人专区视频
 * 千叶
 */
export function newVideo() {
    return request.get("index_video");
}
/**
 * 自营商品分类
 * 千叶
 */
export function categoryList() {
    return request.get("store_category_list");
}
/**
 * 会员中心
 * 千叶
 */
export function memberVip() {
    return request.post("user/member_center");
}
/**
 * 积分明细
 * 千叶
 */
export function intergralList(data) {
    return request.post("intergral_jieshao", data);
}
/**
 * 会员实时收入，会员进度
 * 千叶
 */
export function vipSpeed(data) {
    return request.post("user/speed", data);
}
/**
 * 积分商品转发朋友圈
 * 千叶
 */
export function shareGoods(data) {
    return request.post("member_share", data);
}